/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Button({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeWidth={1.2} clipPath="url(#Button_svg__a)"><path strokeLinecap="round" strokeLinejoin="round" d="M15 7.848V5.64a1.5 1.5 0 0 0-1.5-1.5h-11A1.5 1.5 0 0 0 1 5.64v2.32a1.5 1.5 0 0 0 1.5 1.5H8" /><path strokeLinecap="round" strokeLinejoin="round" d="M8 11.86H2.5a1.5 1.5 0 0 1-1.5-1.5V8.296" /><path strokeLinecap="round" d="m13.051 12.205 1.39 2.407" /><path d="M11.07 8.961c0-.083.09-.135.163-.093l3.584 2.07a.108.108 0 0 1 0 .186l-3.584 2.07a.108.108 0 0 1-.163-.093z" /></g><defs><clipPath id="Button_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;